import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKaggle, faHackerrank } from "@fortawesome/free-brands-svg-icons";
import { CIcon } from "@coreui/icons-react";
import { cibLeetcode } from "@coreui/icons";
import { Tooltip } from "react-tooltip";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.linkedin.com/in/saswat-seth-0a782223b/"
        className="home__social-icon"
        target="_blank"
        rel="noreferrer"
        data-tooltip-id="linkedin-tooltip"
      >
        <i className="uil uil-linkedin"></i>
      </a>
      <Tooltip id="linkedin-tooltip" place="top" content="LinkedIn" />

      <a
        href="https://github.com/Cyberoctane29"
        className="home__social-icon"
        target="_blank"
        rel="noreferrer"
        data-tooltip-id="github-tooltip"
      >
        <i className="uil uil-github-alt"></i>
      </a>
      <Tooltip id="github-tooltip" place="top" content="GitHub" />

      <a
        href="https://www.kaggle.com/saswatsethda"
        className="home__social-icon kaggle-icon-social"
        target="_blank"
        rel="noreferrer"
        data-tooltip-id="kaggle-tooltip"
      >
        <FontAwesomeIcon icon={faKaggle} />
      </a>
      <Tooltip id="kaggle-tooltip" place="top" content="Kaggle" />
      <a
        href="https://leetcode.com/u/cyberoctane/"
        className="home__social-icon"
        target="_blank"
        rel="noreferrer"
        data-tooltip-id="leetcode-tooltip"
      >
        <CIcon icon={cibLeetcode} className="social-icon" />
      </a>
      <Tooltip id="leetcode-tooltip" place="top" content="LeetCode" />

      <a
        href="https://www.hackerrank.com/profile/saswatsethTechie"
        className="home__social-icon"
        target="_blank"
        rel="noreferrer"
        data-tooltip-id="hackerrank-tooltip"
      >
        <FontAwesomeIcon icon={faHackerrank} />
      </a>
      <Tooltip id="hackerrank-tooltip" place="top" content="HackerRank" />
    </div>
  );
};

export default Social;
